var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"}),_c('div',{staticClass:"col-sm-6 pl-5 pr-5"},[_c('br'),_c('br'),_c('Login',{staticClass:"ml-4 mr-4"})],1),_c('div',{staticClass:"col-sm-3"})]),_c('br'),_c('br'),_c('br'),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }